export const completedForm = (input) => {
    return input.some((input) => input === "")
};